import createAPI from './APIRequest';
import {createPromotionSideBlock} from "./elementCreators/createPromotionSideBlock";
import {createRecommendSideBlock} from "./elementCreators/createRecommendSideBlock";
import {createLikeBlock} from "./elementCreators/createLikeBlock";
import {createLikeTopBlock} from "./elementCreators/createLikeTopBlock";
import {createLikeNewsTopBlock} from "./elementCreators/createLikeNewsTopBlock";
import {createNewsCarouselTopBlock} from "./elementCreators/createNewsCarouselTopBlock";
import {createClipNewsTopBlock} from './elementCreators/createClipNewsTopBlock';
import {createClipNewsBottomBlock} from './elementCreators/createClipNewsBottomBlock';
import {createClipNewsSideBlock} from './elementCreators/createClipNewsSideBlock';
import {createClipCategoryNewsBlock} from './elementCreators/createClipCategoryNewsBlock';
import {createClipAuthorBlock} from './elementCreators/createClipAuthorBlock';
import {createClipNewsSeriesBlock} from './elementCreators/createClipNewsSeriesBlock';
import {accordion} from "./accordion";
import {createAlertMessageBlock} from "./elementCreators/createAlertMessageBlock";

export {getResources};

function render($viewer, response, options) {
  if (options.element === 'like') {
    $viewer.appendChild(createLikeBlock(response.total_count ? true : false, options));
  } else if (options.element === 'likeTop') {
    $viewer.appendChild(createLikeTopBlock(response.total_count ? true : false, options));
  } else if (options.element === 'likeNewsTop') {
    $viewer.appendChild(createLikeNewsTopBlock(response.total_count ? true : false, options));
  } else if (options.element === 'carouselTop') {
    if (response && response.data) {
      $viewer.appendChild(createNewsCarouselTopBlock(response.data, options));
      const $pagination = document.createElement('div');
      $pagination.classList.add('news-top-fixed-carousel-pagination');
      $viewer.appendChild($pagination);
    }
  } else if (options.element === 'clipNewsTop') {
    $viewer.appendChild(createClipNewsTopBlock(response.total_count ? true : false, options));
  } else if (options.element === 'clipNewsBottom') {
    $viewer.appendChild(createClipNewsBottomBlock(response.total_count ? true : false, options));
  } else if (options.element === 'clipNewsSide') {
    $viewer.appendChild(createClipNewsSideBlock(response.total_count ? true : false, options));
  } else if (options.element === 'clipCategoryNews') {
    $viewer.appendChild(createClipCategoryNewsBlock(response.total_count ? true : false, options));
  } else if (options.element === 'clipAuthor1' || options.element === 'clipAuthor2') {
    $viewer.appendChild(createClipAuthorBlock(response.total_count ? true : false, options, options.element));
  } else if (options.element === 'clipNewsSeries1' || options.element === 'clipNewsSeries2' || options.element === 'clipNewsSeries3') {
    $viewer.appendChild(createClipNewsSeriesBlock(response.total_count ? true : false, options, options.element));
  } else if (options.element === 'newsCommentReactions') {
    $viewer.querySelectorAll('.' + options.strip_class_name).forEach(el => (response.data.includes(parseInt(el.dataset.comment_id)) || el.classList.remove(options.strip_class_name)));
  } else if (options.element === 'alertMessages') {
    if (response && response.data && response.data.length > 0) {
      response.data.forEach(row => {
        $viewer.appendChild(createAlertMessageBlock(row));
      });
      accordion(Array.prototype.slice.call($viewer.querySelectorAll('.js-accordion-trigger'), 0));
    } else {
      $viewer.remove();
    }
  } else if (options.element === 'promotionSide') {
    response && response.data && response.data.length > 0 && response.data.forEach(row => {
      row.col && (row.col.length >= 4) && $viewer.appendChild(createPromotionSideBlock(row));
    });
  } else if (options.element === 'recommendSide') {
    response && response.data && response.data.length > 0 && response.data.forEach(row => {
      row.col && (row.col.length >= 4) && $viewer.appendChild(createRecommendSideBlock(row));
    });
  }
}

function _getResources(el) {
  createAPI().send(
    el.dataset.resourcesUrl,
    'GET',
    el.dataset.resourcesAuth,
    null,
    function() {},
    function (response) {
      render(el, response, JSON.parse(el.dataset.renderOptions));
    }
  );
}

async function getResources(elements) {
  if (elements.length > 0) {
    elements.forEach(el => {
      if (el.classList.contains('js-member-only') && document.cookie.replace(/(?:(?:^|.*;\s*)token\s*\=\s*([^;]*).*$)|^.*$/, '$1').length <= 0) {
        // ログインしていない場合は実行不要
      } else {
        _getResources(el);
      }
    });
  }
}
